export default __webpack_public_path__ + "static/media/Ficha Técnica - Polpa de Mamão Integral.b583929a.pdf";